import {
  rankWith,
  and,
  isStringControl,
  isEnumControl,
  schemaMatches,
} from '@jsonforms/core';
import { TesterRank } from '@web-config-app/entity-form';
import { SEVERITY_VALUES } from '../constants/severity';

/**
 * Structurally matches the alert-banner severity field: a string enum whose
 * values are exactly informational/warning/critical. Scoped to the alert-banner
 * entity by registration, so it never runs against other entities. Ranked
 * `Highest` to beat the default select control (`isSelectInputControl`, which
 * is `TesterRank.Higher`).
 *
 * If the backend ever changes the severity values, the match simply stops and
 * the field falls back to the default select control — a safe degradation.
 */
export const isAlertBannerSeverityControl = rankWith(
  TesterRank.Highest,
  and(
    isStringControl,
    isEnumControl,
    schemaMatches((schema) => {
      const values = schema.enum ?? [];
      return (
        values.length === SEVERITY_VALUES.length &&
        SEVERITY_VALUES.every((severity) => values.includes(severity))
      );
    }),
  ),
);
